import { object, string } from 'yup';
import './utils/email';

export const BasePhoneEmailValidation = object().shape({
  phone: string()
    .matches(/^(\+3[1-9])\s?\d{8,9}$/, {
      message: 'validations.phone.format',
      excludeEmptyString: true,
    })
    .required('validations.phone.required'),
  email: string()
    .email('validations.email.format')
    .required('validations.email.required'),
});
